import { MobileRegularPage } from '../../../components';
import { AppButton } from "../components/InputComponents";
import { Link } from 'react-router-dom';
import logo from "../../../images/logo_full.png";
import { Box, Typography } from '@material-ui/core';

const FeedBackSubmitted = props => {

    return (
        <MobileRegularPage>
            <Box style={{ textAlign: "center" }}>
                <img src={logo} alt="logo" />
            </Box>

            <Box style={{ marginTop: "20px" }}>
                <Typography variant="h5" className='mt-5' >THANK YOU !</Typography>
                <Typography className='mt-5' >You already submitted your feedback.</Typography>
            </Box>

            <AppButton
                style={{ marginTop: "20px" }}
                variant="contained"
                color="secondary"
                fullWidth
                size="large"
                component={Link}
                to="/app/dashboard"
            >
                Back To Dashboard
            </AppButton>
        </MobileRegularPage>
    )
}
export default FeedBackSubmitted